(() => {
  const root = document.documentElement;
  let requestNumber = 0;

  function applyCart(cart) {
    if (!Array.isArray(cart?.items)) return false;
    root.dataset.pbdRequiresShipping = String(cart.items.some(item => item.requires_shipping));
    return true;
  }

  async function refreshCart() {
    const currentRequest = ++requestNumber;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (currentRequest === requestNumber) applyCart(cart);
    } catch {}
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      ++requestNumber;
      if (!applyCart(event.cartData)) refreshCart();
    });
  }
  window.addEventListener('pageshow', event => {
    if (event.persisted) refreshCart();
  });
})();
